import { css, styled } from 'styled-components';
import {
  BodyHeavy,
  BodyLight,
  Button,
  Colors,
  H2Heavy,
  MediaQuery,
  SmallLight,
  Theme,
} from '@pelando/components';

import BaseCashbackIcon from '@/resources/supercashback/cashback-icon.svg?component';

export const modalStyle = css`
  padding: 16px 16px 24px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    width: 500px;
    padding: 24px 24px 32px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${MediaQuery.SCREEN_MD_UP} {
    padding: 0 34px;
  }
`;

export const CashbackIcon = styled(BaseCashbackIcon)`
  fill: rgb(${Theme.colors.Brand});
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
`;

export const Title = styled.h2`
  ${H2Heavy}
  margin-bottom: 8px;
  text-align: center;
`;

export const Subtitle = styled.p`
  ${BodyLight}
  color: rgb(${Colors.Gray});
  margin-bottom: 16px;
  text-align: center;
`;

export const Tip = styled.div`
  ${SmallLight}
  display: flex;
  gap: 8px;
  padding: 12px 8px;
  border-radius: 8px;
  background: rgb(${Theme.colors.Kilo});
  margin-bottom: 24px;
  align-items: start;

  i {
    font-size: 24px;
    color: rgb(${Theme.colors.Brand});
  }
`;

export const EnableCashbackButton = styled(Button)`
  ${BodyHeavy}
  width: 100%;
  padding: 14px 24px;
  margin-bottom: 8px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    max-width: 308px;
  }
`;

export const GoToStoreWithoutCashbackButton = styled(Button).attrs({
  light: true,
})`
  ${BodyHeavy}
  width: 100%;
  padding: 14px 24px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    max-width: 308px;
  }
`;
